import {slugify} from '@ivosabev/helpers/slugify';
import {type Quote} from '#/app/types.js';

export function getQuoteImage(quote: Quote) {
  const tmp = `/people/${slugify(`${quote.person}-${quote.company}`)}.jpg`;
  return tmp;
}
